module.exports = __webpack_public_path__ + "static/img/indexBg.d331c859.png";